import React from "react";
import Hero from './Hero';
import CoreValues from './CoreValues';
import Global from './Global';
import ExpertiseSection from "./Expertise";

const About = () => {
    return (
<>
<Hero/>
<CoreValues/>

<Global/>
<ExpertiseSection/>
</>

    );
};

export default About;